export default __webpack_public_path__ + "static/media/bing_grey.0e15087a.svg";